import { ROLE } from "../../../../data/enums";

const MISSING_ONLY_ROLES: ROLE[] = [
  ROLE.FACTORY_MANAGER_ONE,
  ROLE.FACTORY_MANAGER_TWO,
  ROLE.DEPUTY_FACTORY_MANAGER_ONE,
  ROLE.DEPUTY_FACTORY_MANAGER_TWO,
  ROLE.FIRST_STORAGE_KEEPER,
];

export const getProductTabPolicy = (
  role: ROLE,
  missingProductCount: number,
) => {
  const hasMissingProducts = missingProductCount > 0;

  return {
    showTabs: hasMissingProducts,
    showListTab: hasMissingProducts && !MISSING_ONLY_ROLES.includes(role),
    defaultTab: hasMissingProducts ? "missing" : "list",
  };
};
